export default { sha: '475e9d96b950691c697bf1346d9507de299b8acb', buildNumber: 'undefined' }
